import { render } from "./issue_row.vue?vue&type=template&id=8b7fcc7c&scoped=true&lang=pug"
import script from "./issue_row.vue?vue&type=script&lang=js"
export * from "./issue_row.vue?vue&type=script&lang=js"

import "./issue_row.vue?vue&type=style&index=0&id=8b7fcc7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7fcc7c"]])

export default __exports__